(function () {
  'use strict';
  const languages = ['en', 'fr', 'de', 'es', 'ru'];
  function parseTiers(source) {
    if (typeof source !== 'string') return null;
    const parts = source.replace(/&nbsp;|&#160;|&#xA0;/gi, ' ').trim().split('|');
    if (!parts.length || parts.length > 5) return null;
    const tiers = parts.map(function (part) {
      const match = part.trim().match(/^\$\s*(\d+(?:\.\d+)?)\s+Off\s+\$\s*(\d+(?:\.\d+)?)\s*\+$/i);
      if (!match) return null;
      const discount = Number(match[1]), min = Number(match[2]);
      return discount > 0 && min > discount ? { min: min, discount: discount } : null;
    });
    return tiers.every(Boolean) ? tiers : null;
  }
  function buildText(language, currency, rate, baseCurrency, expectedCurrency, tiers) {
    if (!languages.includes(language)) return null;
    const validRate = baseCurrency === 'USD' && currency === expectedCurrency &&
      /^[A-Z]{3}$/.test(currency || '') && Number.isFinite(rate) && rate > 0;
    function money(usd) {
      if (!validRate) return usd + ' USD';
      if (currency === 'USD') return '$' + usd;
      try {
        return new Intl.NumberFormat(language, {
          style: 'currency', currency: currency, currencyDisplay: 'symbol'
        }).format(usd * rate);
      } catch (error) {
        return usd + ' USD';
      }
    }
    function tier(minimum, discount) {
      const min = money(minimum), off = money(discount);
      if (language === 'en') return off + ' Off ' + min + '+';
      if (language === 'fr') return off + ' de réduction dès ' + min;
      if (language === 'de') return off + ' Rabatt ab ' + min;
      if (language === 'es') return off + ' de descuento desde ' + min;
      return 'Скидка ' + off + ' от ' + min;
    }
    return (tiers || [{ min: 99, discount: 10 }, { min: 129, discount: 15 }])
      .map(function (entry) { return tier(entry.min, entry.discount); }).join(' | ');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { buildText, parseTiers };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.geekoLocalizedPromoLoaded) return;
  window.geekoLocalizedPromoLoaded = true;
  const sectionSources = new Map();
  function announcementTiers(el) {
    if (!languages.includes(el.dataset.promoLanguage)) return null;
    const id = el.dataset.promoSourceSection;
    if (!id || !el.dataset.promoSourceBlock) return null;
    if (!sectionSources.has(id)) {
      const state = { blocks: null };
      sectionSources.set(id, state);
      const url = new URL('/', window.location.origin);
      url.searchParams.set('section_id', id);
      url.searchParams.set('locale', 'en');
      if (el.dataset.promoCountry) url.searchParams.set('country', el.dataset.promoCountry);
      if (el.dataset.promoCurrency) url.searchParams.set('currency', el.dataset.promoCurrency);
      const theme = window.Shopify && window.Shopify.theme;
      if (theme && theme.role !== 'main' && theme.id) url.searchParams.set('preview_theme_id', String(theme.id));
      window.fetch(url.toString(), { credentials: 'same-origin', headers: { 'Accept-Language': 'en' } })
        .then(function (response) { if (!response.ok) throw new Error('Source unavailable'); return response.text(); })
        .then(function (html) {
          const source = new DOMParser().parseFromString(html, 'text/html');
          const blocks = new Map();
          source.querySelectorAll('[data-promo-kind="announcement"]').forEach(function (node) {
            if (node.dataset.promoSourceLanguage === 'en') {
              blocks.set(node.dataset.promoSourceBlock, parseTiers(node.dataset.promoSourceText));
            }
          });
          state.blocks = blocks;
          schedule();
        }).catch(function () { state.blocks = new Map(); });
    }
    const state = sectionSources.get(id);
    return state.blocks && state.blocks.get(el.dataset.promoSourceBlock);
  }
  function update() {
    const presentment = window.Shopify && window.Shopify.currency;
    const currency = presentment && presentment.active;
    const rate = Number(presentment && presentment.rate);
    document.querySelectorAll('[data-geeko-converted-promo]').forEach(function (el) {
      const tiers = el.dataset.promoKind === 'announcement' ? announcementTiers(el) : undefined;
      if (el.dataset.promoKind === 'announcement' && !tiers) return;
      const text = buildText(el.dataset.promoLanguage, currency, rate,
        el.dataset.promoBaseCurrency, el.dataset.promoCurrency, tiers);
      if (text !== null && el.textContent !== text) el.textContent = text;
    });
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; update(); });
  }
  function boot() {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  ['shopify:section:load', 'localization:change', 'currency:change'].forEach(function (event) {
    document.addEventListener(event, function () {
      if (event === 'shopify:section:load') sectionSources.clear();
      schedule();
    });
  });
  window.addEventListener('pageshow', schedule);
})();
